<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-product-box">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div class="row">
        <div class="col-md-12 mb-20">
          <label class="d-block text-black fw-semibold mb-10">
            Image du produit
          </label>
          <div class="d-flex align-items-center">
            <img
              :src="
                product.pic
                  ? product.pic
                  : require('@/assets/images/NoImage.png')
              "
              class="rounded-circle me-15"
              style="width: 90px; height: 90px; object-fit: cover"
            />

            <!-- <div>
              <input
                ref="updateImgInput"
                type="file"
                accept="image/*"
                class="d-none"
                @change="logoSelected"
              />
              <button
                type="button"
                class="btn btn-primary me-2"
                @click="() => updateImgInput?.click()"
              >
                Choisir la photo
              </button>
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click="cancelImage"
              >
                Annuler
              </button>
            </div> -->
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group mb-15 mb-sm-20 mb-md-25">
            <label class="d-block text-black fw-semibold mb-10"
              >Nom du produit</label
            >
            <input
              type="text"
              class="form-control shadow-none rounded-0 text-black"
              placeholder="e.g. Sensung Smart Watch"
              v-model="product.name"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group mb-15 mb-sm-20 mb-md-25">
            <label class="d-block text-black fw-semibold mb-10">
              Description Produit
            </label>
            <div class="mb-0">
              <textarea
                v-model="product.desc"
                placeholder="Write your product description"
                class="form-control shadow-none rounded-0 text-black"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <button
            class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
            @click="editProduct"
          >
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  </div>

  <vue-good-table :columns="columns" :rows="product.variantsList">
    <template #table-row="props">
      <!-- Column: Name -->
      <span v-if="props.column.field === 'inventory_ref'" class="text-nowrap">
        <span class="text-nowrap">{{ props.row.inventory_ref }}</span>
      </span>

      <span v-else-if="props.column.field === 'stores'" class="text-nowrap">
        <template
          v-if="
            props.row.inventories_stores &&
            props.row.inventories_stores.length != 0
          "
        >
          <span
            class="text-nowrap"
            v-for="(str, indx) in props.row.inventories_stores"
            :key="indx"
          >
            {{ str.magasin.name }}
            <small> ({{ str.magasin.market }})</small></span
          >
        </template>
      </span>

      <!-- Column: Status -->
      <span v-else-if="props.column.field === 'qty_not_received'">
        <div class="d-flex align-items-center">
          <input
            type="number"
            min="-500000"
            max="500000"
            class="form-control"
            v-model="props.row.qty_not_received"
          />
          <button
            style="margin-left: 1%"
            class="btn btn-info"
            @click="editQnty(props.row)"
          >
            <i class="ph ph-floppy-disk"></i>
          </button>
        </div>
      </span>

      <!-- Column: Common -->
      <span v-else>
        {{ props.formattedRow[props.column.field] }}
      </span>
    </template>
  </vue-good-table>

  <div class="row mt-40">
    <div class="col-md-6 mb-2">
      <div class="card mb-25 border-0 rounded-0 bg-white add-product-box">
        <div class="card-header">
          <h5>Historique</h5>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <vue-good-table :columns="columnsHist" :rows="histories">
            <!-- <template v-slot:emptystate></template> -->
            <template #emptystate>
              <center>Aucune entrées correspondants trouvés</center>
            </template>
            <template #table-row="props">
              <template v-if="props.column.field === 'history_type'">
                <b>{{ props.row.text }}</b>
              </template>
              <template v-else-if="props.column.field === 'created_at'">
                <span>{{ getDate(props.row.created_at) }}</span
                ><br />
              </template>

              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
    <div class="col-md-6 mb-2">
      <div class="card mb-25 border-0 rounded-0 bg-white add-product-box">
        <div class="card-header">
          <h5>Colis avec ce produit</h5>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <vue-good-table :columns="columnsColis" :rows="colis">
            <!-- <div slot="emptystate"></div> -->
            <template #emptystate>
              <center>Aucune entrées correspondants trouvés</center>
            </template>
            <template #table-row="props">
              <template v-if="props.column.field === 'parcel_code'">
                <span>{{ props.row.parcel_code }}</span
                ><br />
              </template>
              <template v-else-if="props.column.field === 'created_at'">
                <span>{{ getDate(props.row.created_at) }}</span>
              </template>

              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import moment from "moment";
import { defineComponent, onMounted, reactive, ref } from "vue";

export default defineComponent({
  name: "EditProduct",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup: (props) => {
    const auth = useAuthStore();
    const user = auth.user;

    const updateImgInput = ref<HTMLInputElement | null>(null);
    const imagepreview = ref<string | null>(null);
    const loading = ref(false);
    const agencyList = ref([]);
    const agency = ref(null);

    const { showToast } = useAppToast();

    const variants = ref(false);
    const items = ref([{ id: Date.now(), ref: "", name: "", qnty: 1 }]);
    const customer = ref<{ id?: number; name?: string }>({});
    const prod_name = ref("");
    const ref_prod = ref("");
    const note_prod = ref("");
    const qnty = ref(1);
    const image = ref<File | null>(null);

    const product = reactive({
      pic: null as File | null,
      id: 0,
      customer: 0,
      customer_name: "",
      name: "",
      desc: "",
      variant: 0,
      stock_zone: null,
      stock_agency: null,
      stock_agency_name: null,
      received: 0,
      received_time: null,
      received_by: null,
      received_by_name: null,
      added_time: null,
      created_at: "",
      updated_at: "",
      variantsList: [],
    });
    const histories = ref([]);
    const colis = ref([]);

    const columns = [
      {
        label: "#Réf",
        field: "inventory_ref",
      },
      {
        label: "Nom de la variante",
        field: "var_name",
      },
      {
        label: "Reçu",
        field: "qty",
      },
      {
        label: "Pas encore reçu",
        field: "qty_not_received",
      },
      
      // {
      //   label: "Action",
      //   field: "action",
      // },
    ];
    const columnsHist = [
      {
        label: "Historique",
        field: "history_type",
      },
      {
        label: "Date",
        field: "created_at",
      },
    ];
    const columnsColis = [
      {
        label: "Code d'envoi",
        field: "parcel_code",
      },
      {
        label: "Date",
        field: "created_at",
      },
    ];

    // 🟢 Fetch clients
    onMounted(async () => {
      showProduct();

      // historiques
      fetchHistories();
      // colis
      fetchColis();
    });

    async function showProduct() {
      // 🟢 Fetch existing product details
      try {
        const res = await api.get(`/api/auth/client/show_product/${props.id}`);
        const p = res.data;

        Object.assign(product, p);
      } catch (error) {
        console.error("Error fetching product:", error);
        showToast("Impossible de charger le produit", "error");
      }
    }

    const logoSelected = (e: Event) => {
      const target = e.target as HTMLInputElement;
      const file = target.files?.[0];

      if (file) {
        image.value = file;
        imagepreview.value = URL.createObjectURL(file);
      }
    };

    const cancelImage = () => {
      image.value = null;
      imagepreview.value = null;
      if (updateImgInput.value) updateImgInput.value.value = "";
    };

    const repeateAgain = () => {
      items.value.push({
        id: Date.now() + Math.random(),
        ref: "",
        name: "",
        qnty: 1,
      });
    };

    const removeItem = (index: number) => {
      items.value.splice(index, 1);
    };

    // 🟢 Update Product
    async function updateProduct() {
      if (Object.keys(customer.value).length === 0) {
        showToast("Merci de choisir un client", "error");
        return;
      }

      const data = new FormData();
      data.append(
        "cstmr_id",
        customer.value.id !== undefined ? String(customer.value.id) : ""
      );
      data.append("cstmr_name", customer.value.name ?? "");
      data.append("prod_name", prod_name.value ?? "");
      data.append("prod_desc", note_prod.value ?? "");
      data.append("ref_prod", ref_prod.value ?? "");
      data.append("list", JSON.stringify(items.value));
      data.append("variants", variants.value ? "1" : "0");
      data.append("qnty", String(qnty.value ?? 1));

      if (image.value) {
        data.append("image", image.value); // only send new image
      }

      loading.value = true;
      try {
        const res = await api.post(
          `/api/auth/updateProduct/${props.id}`,
          data,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        loading.value = false;

        if (res.data.message === "success") {
          showToast("Produit mis à jour avec succès", "success");
        } else if (res.data.message === "exist") {
          showToast(
            "Cette référence " + res.data.ref + " est déjà existante",
            "error"
          );
        }
      } catch (error) {
        loading.value = false;
        console.error(error);
        showToast("Erreur lors de la mise à jour", "error");
      }
    }

    async function receivedAgency() {
      if (Object.keys(agency.value).length == 0) {
        showToast("Merci de choisir une agence", "error");
      } else {
        let data = new FormData();
        data.append("agency_id", agency.value.id);
        data.append("agency_name", agency.value.name);
        data.append("prod_id", props.id);
        data.append("user_id", user?.id);
        data.append("user_name", user?.name);
        try {
          const res = await api.post(`/api/auth/Received`, data);
          if (res.data.message == "success") {
            showProduct();
            showToast("ajouté avec succès", "success");
          }
        } catch (error) {
          showToast("Erreur lors de l'ajout", "error");
        }
      }
    }
    async function receiveInventory(row) {
      if (product.received == 0) {
        showToast(
          "Le produit doit être reçu par une agence avant d'être ajouté à l'inventaire",
          "error"
        );
      } else {
        let data = new FormData();
        data.append("var_id", row.id);
        data.append("prod_id", props.id);
        const res = await api.post(`/api/auth/ReceiveInventory`, data);
        if (res.data.message == "success") {
          showProduct();
          fetchHistories();
          showToast("ajouté avec succès", "success");
        } else {
          showToast("Erreur lors de l'ajout", "error");
        }
      }
    }

    async function editQnty(row) {
      let data = new FormData();
      data.append("var_id", row.id);
      data.append("qnty", row.qty_not_received);
      // data.append('prod_id', row.code_color);
      const res = await api.post(`/api/auth/client/editVariant`, data);
      if (res.data.message == "success") {
        showProduct();
        fetchHistories();
        showToast("Quantité modifiée avec succès", "success");
      }
    }
    function getDate(value) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    async function fetchHistories() {
      try {
        const res = await api.get(
          `/api/auth/client/show_history_prod/${props.id}`
        );
        // if (res.data.message == "success") {
        histories.value = res.data;
        // }
      } catch (error) {
        console.error(error);
      }
    }
    async function fetchColis() {
      try {
        const res = await api.get(
          `/api/auth/client/ProductParcels?prod_id=${props.id}`
        );
        // if (res.data.message == "success") {
        colis.value = res.data;
        // }
      } catch (error) {
        console.error(error);
      }
    }

    async function editProduct() {
      const data = new FormData();
      data.append("customer_id", String(product.customer));
      data.append("product_id", String(product.id));
      data.append("pic", image.value ?? "");
      data.append("desc", product.desc);
      data.append("name", product.name);
      const res = await api.post(`/api/auth/client/EditProd`, data);
      if (res.data.message == "success") {
        showProduct();
        showToast("Produit modifié avec succès", "success");
      } else if (res.data.message == "error customer") {
        showToast("Erreur Client: Vous pouvez pas modifier ce produit", "error");
      } else if (res.data.message == "no product") {
        showToast("Erreur Produit: Ce produit n'existe pas", "error");
      }

    }
            
        

    return {
      updateImgInput,
      imagepreview,
      logoSelected,
      cancelImage,
      variants,

      repeateAgain,
      removeItem,
      items,
      updateProduct,

      loading,
      customer,
      ref_prod,
      prod_name,
      note_prod,
      qnty,
      image,
      product,
      auth,
      receivedAgency,
      receiveInventory,
      editQnty,
      agency,
      agencyList,
      getDate,

      columnsColis,
      columnsHist,
      columns,
      histories,
      colis,
      editProduct,
    };
  },
});
</script>
